import { IGetUsersListDTO } from '@/models/users.model';

class GetUsersListDTO implements IGetUsersListDTO {
  id?: string;
  full_name?: string;
  phone?: string;
  active?: '0' | '1';
  created_at?: string;
  limit?: number;
  page?: number;

  constructor({
    full_name,
    phone,
    page,
    size,
    active,
    created_at,
  }: {
    full_name?: string;
    phone?: string;
    created_at?: string;
    active?: string;
    page?: number;
    size?: number;
  }) {
    this.full_name = full_name;
    this.phone = phone;
    this.limit = size;
    this.active = active as '0' | '1';
    this.limit = 10;
    this.created_at = created_at;
    this.page = page ?? 1;
  }
}

export default GetUsersListDTO;
